import { useEffect, useState } from 'react';

const ADD_UPDATE_LOCK = 'ADD_UPDATE_LOCK';
const RECLAIM_UPDATE_LOCK = 'RECLAIM_UPDATE_LOCK';

export const lockApplicationUpdate = () => window.dispatchEvent(new Event(ADD_UPDATE_LOCK));
export const unlockApplicationUpdate = () => window.dispatchEvent(new Event(RECLAIM_UPDATE_LOCK));

export const useIsApplicationUpdateLocked = () => {
  const [lockCount, setLockCount] = useState(0);

  useEffect(() => {
    const lockCountIncrement = () => setLockCount((prev) => prev + 1);
    const lockCountDecrement = () => setLockCount((prev) => Math.max(prev - 1, 0));

    window.addEventListener(ADD_UPDATE_LOCK, lockCountIncrement);
    window.addEventListener(RECLAIM_UPDATE_LOCK, lockCountDecrement);

    return () => {
      window.removeEventListener(ADD_UPDATE_LOCK, lockCountIncrement);
      window.removeEventListener(RECLAIM_UPDATE_LOCK, lockCountDecrement);
    };
  }, []);

  return { isUpdateLocked: lockCount > 0 };
};
